/* ViewPage.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./ViewPage.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useMemo } from 'react';
import { ExperienceNames } from '../experience-tracker';
import { EMBEDDED_CONFLUENCE_CONTENT_TYPE, EMBEDDED_CONFLUENCE_MODE, useContentSize } from '../page-common';
import { Content } from '../content';
import { useGetCurrentScrollPosition } from '../page-common/useGetCurrentScrollPosition';
var embeddedPageContainerSytles = null;
var StyledEmbeddedPageContainer = function StyledEmbeddedPageContainer(_ref) {
  var children = _ref.children,
    containerHeight = _ref.containerHeight;
  return /*#__PURE__*/React.createElement("div", {
    "data-testId": "styled-embedded-page-container-id",
    style: {
      height: containerHeight
    },
    className: ax(["_1e0c1txw _2lx21bp4"])
  }, children);
};
export var ViewPage = function ViewPage(props) {
  var shouldShowFooter = props.hasFooterLogo,
    isHeightSetFromContent = props.isHeightSetFromContent,
    _props$showFooter = props.showFooter,
    showFooter = _props$showFooter === void 0 ? true : _props$showFooter;
  var _useContentSize = useContentSize(),
    height = _useContentSize.height;
  useGetCurrentScrollPosition(isHeightSetFromContent);
  var contentConfiguration = useMemo(function () {
    return {
      experiences: {
        experience: ExperienceNames.VIEW_PAGE,
        ccExperience: ExperienceNames.CC_VIEW_PAGE
      },
      getWrapperElement: function getWrapperElement(children) {
        return /*#__PURE__*/React.createElement(StyledEmbeddedPageContainer, {
          containerHeight: isHeightSetFromContent ? "".concat(height, "px") : '100%'
        }, children);
      },
      hasFooter: showFooter
    };
  }, [isHeightSetFromContent, height, showFooter]);
  return /*#__PURE__*/React.createElement(Content, _extends({}, props, {
    contentType: EMBEDDED_CONFLUENCE_CONTENT_TYPE.PAGE,
    mode: EMBEDDED_CONFLUENCE_MODE.VIEW_MODE,
    contentConfiguration: contentConfiguration,
    isHeightSetFromContent: isHeightSetFromContent,
    shouldShowFooter: shouldShowFooter
  }));
};